import { GetAllItemRequestsForAdminState } from './getAllItemRequestsForAdmin.types'

const initialState: GetAllItemRequestsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
